// Sample loading plan as it might come out of SAP / the planner's Excel.
// Dates are today so the import always validates; three rows are
// deliberately wrong (missing carrier, duplicate delivery, unknown carrier).
export function samplePlanTsv() {
  const d = new Date();
  const today = `${d.getDate()}. ${d.getMonth() + 1}. ${d.getFullYear()}`;
  const rows = [
    ['Dodávka', 'Zákazník', 'Materiál', 'Množství', 'Dopravce', 'Datum', 'Čas', 'Typ'],
    ['DOD 80452401', 'Papírny Ostrava a.s.', 'Omyacarb 2-AV', '26', 'Karpaty Trans', today, '15:45', 'silo'],
    ['DOD 80452402', 'Chemia Opole S.A.', 'Omyacarb 10-AV', '25', 'Opolski Transport', today, '16:15', 'silo'],
    ['DOD 80452403', 'Tynk Polska Sp. z o.o.', 'Omyacarb 15-GU (big bag)', '24', 'Moravia Cargo', today, '17:00', 'palety'],
    ['DOD 80452404', 'Agro Haná a.s.', 'Omyacarb 5-AV', '25', 'Jesenická doprava', today, '17:30', 'silo'],
    ['DOD 80452405', 'Plasty Zlín s.r.o.', 'Omyacarb 40-GU', '26', '', today, '18:00', 'silo'],
    ['DOD 80452311', 'Kabely Morava s.r.o.', 'Omyacarb 2-AV', '26', 'Śląsk Przewozy', today, '13:30', 'silo'],
    ['DOD 80452406', 'Farby Śląskie S.A.', 'Omyacarb 2-AV', '27', 'TransEuro Logistik', today, '18:30', 'silo'],
  ];
  return rows.map(r => r.join('\t')).join('\n');
}
